import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SpeakerIcon = ({
  color = "#fff",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.154 7.912v2.9M5.6 12.621v3.08c0 .169 0 .253.007.324.07.688.624 1.233 1.325 1.3.073.007.158.007.33.007.171 0 .257 0 .33-.007a1.463 1.463 0 0 0 1.324-1.3c.007-.07.007-.155.007-.323v-3.08m-3.323 0c-.688 0-1.032 0-1.304-.11a1.464 1.464 0 0 1-.799-.785c-.112-.266-.112-.604-.112-1.28V9.58c0-1.217 0-1.826.241-2.291.213-.41.552-.742.968-.95C5.068 6.1 5.69 6.1 6.93 6.1h1.994M5.6 12.623h3.323m0 0h.554c1.304 0 2.9.686 4.131 1.345.718.384 1.077.576 1.313.548a.7.7 0 0 0 .51-.298c.138-.19.138-.568.138-1.324V5.83c0-.757 0-1.135-.138-1.325a.701.701 0 0 0-.51-.297c-.236-.028-.595.164-1.313.548-1.23.658-2.827 1.345-4.13 1.345h-.555m0 6.522V6.1"
    />
  </svg>
);
export default SpeakerIcon;
